<template lang="pug">
div.p-2
  b-form-row.align-items-center.mb-3.p-2
    b-col(cols="auto")
      Avatar.mr-3(size="xs", :src="userData.profile_pic", :platform="conversation.platform")
    b-col
      span {{ userName.trim() || 'Usuario' }}
    b-col(cols="auto")
      b-button(variant="primary" size="sm", @click="confirmCreateNewOrder") Nueva orden
  div(v-show="order.order_id")
    b-form-row.mb-3.align-items-center
      b-col
        h5.mb-0 Orden de Compra

    // PERSONAL DATA
    b-list-group.mb-3
      b-list-group-item
        div.mb-3
          span.font-weight-bold Orden:
          span.ml-2 {{ order.reference }}
        b-form-row.mb-3
          b-col
            div
              span.font-weight-bold Status:
              span.mb-0.ml-2 {{ getStatusName(order.status) }}
                check-circle-icon.icon-sm.ml-2.text-success(v-if="order.status == 'paid'")
          b-col.text-right
            b-link.text-sm(@click="status_modal = true;") Cambiar status
        div.mb-3(v-if="order.updatedAt")
          span.font-weight-bold Fecha:
          span.ml-2 {{ $moment(order.updatedAt).tz(this.timezone).format("DD MMMM YYYY, HH:mm A") || 'No definido' }}
        div.mb-3
          .text-right
            b-link.text-sm(@click="info_modal = true;") Configurar datos
          span.font-weight-bold Nombre:
          span.ml-2 {{ order.name || 'No definido' }}
        div.mb-3
          span.font-weight-bold Teléfono:
          span.ml-2 {{ order.phone || 'No definido' }}
        div
          span.font-weight-bold Correo:
          span.ml-2 {{ order.email || 'No definido' }}

      b-list-group-item
        b-form-row.mb-3
          b-col
            p.mb-0.font-weight-bold Tipo de envío:
            p.mb-0(v-if="order.delivery_type") {{ getDeliveryName(order.delivery_type) }}
            p.mb-0.text-secondary(v-else) No seleccionado
          b-col.text-right
            b-link.text-sm(@click="delivery_modal = true;") Configurar envío

        div.mb-3(v-if="order.delivery_type == 'kanguro' && order.track_id")
          p.mb-0.font-weight-bold Guía de rastreo:
          p.mb-0 {{ order.track_id }}

        div
          p.mb-0.font-weight-bold Dirección de entrega:
          p.mb-0(v-if="order.delivery_address || order.pickup_location_id") {{ getDeliverFullAddress() }}
          p.mb-0.text-secondary(v-else) Aún no proporcionada

    // ORDER
    b-list-group.mb-3
      b-list-group-item.bg-light
        .d-flex.align-items-center.justify-content-between
          span.font-weight-bold Pedido
          //- b-link.text-sm(@click='getPaymentUrl') Enviar liga de pago
          b-button(variant="primary" size="sm" @click="products_modal = true;") Agregar producto
      // order summary
      b-list-group-item.scrollable-area.overflow-auto.max-h-250
        p.mb-0.text-secondary(v-if="!order_summary.length") No se han agregado productos a la orden

        b-form-row.product-row(v-for="(item, index) in order_summary" :key="index")
          b-col(cols="auto")
            b-img(width="60" height="60" rounded :src="item.image" :blank="!item.image" blank-color="#f2f2f2" style="object-fit:cover;")
          b-col
            b-form-row
              b-col
                p.font-weight-bold.mb-0 {{ item.product }}
              b-col(cols="auto")
                p.font-weight-bold.mb-0 {{ itemPrice = parsePrice(item.price) }}
              b-col(cols="12")
                ul(v-if="item.variants && item.variants.length")
                  li.text-secondary(v-for="item_v in item.variants" :key="item_v") {{item_v}}
                //.d-flex.align-items-center.justify-content-between
                  p.mb-0.text-secondary {{ item.quantity }} {{item.quality > 1 ? "unidades" : "unidad"}}
                  b-link.text-danger.text-sm(@click="removeProduct(item)") Quitar
                b-form-group.mt-2
                  b-input-group(size="sm")
                    b-input-group-prepend
                      b-button(variant="soft-danger", @click="updateQuantity(item, '-')")
                        trash-2-icon.icon-sm(v-if="item.quantity <= 1")
                        minus-icon.icon-sm(v-else)
                    b-form-input(readonly, :value="`${item.quantity} ${item.quantity > 1 ? 'unidades' : 'unidad'}`")
                    b-input-group-append
                      b-button(variant="soft-success", :disabled="item.quantity >= item.stock", @click="updateQuantity(item, '+')")
                        plus-icon.icon-sm
                  span.text-sm.text-danger(v-if="item.quantity >= item.stock") No hay más unidades disponibles

      // total summary
      b-list-group-item
        b-form-row.mb-2
          b-col
            span Subtotal:
          b-col(cols="auto")
            span {{ order.total || 0 }}

        b-form-row.mb-2
          b-col
            span Envío:
          b-col(cols="auto")
            span {{ orderDelivery = parsePrice(order.delivery_price) }}
        b-form-row
          b-col
            span Descuento:
          b-col(cols="auto")
            span {{ discount || 0 }} %

        .mb-2
          b-link.text-sm(@click="discount_modal = true;") Agregar descuento

        b-form-row.font-weight-bold
          b-col
            span Total:
          b-col(cols="auto")
            span {{ order.total_final || 0 }}
        b-form-row.d-flex.justify-content-end.mt-2
          b-col(cols="auto")
            b-button(variant="primary" size="sm" @click="generatePayment") Generar orden

    // PRODUCTS GALLERY
    //b-list-group.mb-3
      b-list-group-item.bg-light
        .d-flex.align-items-center.justify-content-between
          span.font-weight-bold Productos
          b-button(variant="primary" size="sm" @click="products_modal = true;") Buscar producto

      b-list-group-item
        b-form-row.product-row(v-for="product in products.slice(0, 3)" :key="product.product_id")
          b-col(cols="auto")
            b-img(width="60" height="60" rounded :src="product.image" :blank="!product.image" blank-color="#f2f2f2" style="object-fit:cover;")
          b-col
            p.font-weight-bold.mb-0 {{ product.name }}
            p.mb-0 {{ product.description }}

    // STATUS
    SideModal(v-model="status_modal" padding)
      template
        b-list-group.mb-3
          b-list-group-item.bg-light
            b-row.align-items-center
              b-col
                p.font-weight-bold.mb-0 Status de la orden
              b-col(cols="auto")
                b-button(variant="primary" size="sm" @click="updateOrderStatus(order_status.find(s => s.name == status))") Aplicar
          b-list-group-item(v-for="(_status, index) in order_status", :key="index" v-if="_status.name == 'pay_on_delivery' || _status.name == 'paid' || !_status.meta || !_status.meta.hidden")
            b-form-radio(name="status" :value="_status.name" v-model="status" :disabled="_status.name == 'paid'")
              p.font-weight-bold.mb-0 {{ _status.title }}
              span.text-secondary.text-sm {{ _status.description }}

        b-form-checkbox.text-secondary(v-model="notify_checkbox" size="sm") Notificar al usuario el cambio de status en un mensaje en el chat

    // PERSONAL INFO
    SideModal(v-model="info_modal" padding)
      template
        b-card.no-shadow
          p.font-weight-bold Datos personales
          b-form
            b-form-group(label="Nombre:")
              b-form-input(placeholder="Nombre", v-model="order.name")
            b-form-group(label="Teléfono:")
              b-form-input(placeholder="Teléfono", v-model="order.phone")
            b-form-group(label="Correo:")
              b-form-input(placeholder="Correo", v-model="order.email")
        .mt-3.text-right
          b-button.px-4(variant="primary", size="sm", :disabled="loading", @click="updateOrder({ name: order.name, phone: order.phone, email: order.email}, true)") Guardar

    // DISCOUNT
    SideModal(v-model="discount_modal" padding)
      template
        b-list-group
          b-list-group-item.bg-light
            b-form-row.align-items-center
              b-col
                span.font-weight-bold Agregar descuento
              b-col(cols="auto")
                b-button(variant="primary" size="sm" @click="addDiscount(discount)") Aplicar
          b-list-group-item
            b-form-group(label="Introduce porcentaje de descuento")
              b-input-group(append="%")
                b-form-input(v-model="discount" :state="validDiscount" type="number")

    // DELIVERY TYPE
    SideModal(v-model="delivery_modal" padding)
      template
        b-input-group.mb-3
          template(#prepend)
            b-input-group-text.bg-light Envíos
          b-form-select(v-model="delivery_type" :options="deliveryTypes" :state="delivery_type ? null : false" @change="updateOrder({delivery_type: delivery_type}, true)")
            template(#first)
              b-form-select-option(:value="null" disabled) -- Seleccionar --

        b-list-group.mb-3(v-if="defined_delivery")
          b-list-group-item.bg-light
            .d-flex.align-items-center.justify-content-between
              span.font-weight-bold Direcciónes
          b-list-group-item
            b-form-group
              b-form-checkbox.mb-2(v-model="selected_address", v-for="pickup in pickup_locations", :key="pickup.pickup_location_id", :value="pickup", stacked, @change="setLocation")
                p.mb-0(v-if="pickup.name") {{ pickup.name }}
                p.mb-0.text-help(v-else) (Sin nombre)
                p.mb-0.text-secondary {{ pickup.description }}
                p.mb-0.text-secondary.text-sm {{ pickup.disponibility_description }}
                p.mb-0.text-help.text-sm.text-justify {{ pickup.full_address }}

        b-card.no-shadow(v-else)
          b-form-row.mb-2
            b-col
              span.font-weight-bold Costo de envío
            b-col(cols="5")
              b-input-group
                b-input-group-prepend(is-text)
                    dollar-sign-icon.icon-sm
                b-form-input.text-right(v-model="order.delivery_price" type="number" @change="updateOrder({delivery_price: order.delivery_price || 0}, true)" size="sm" placeholder="$0.00" :lazy="true" debounce="600")
          b-form-row
            b-col
              span.font-weight-bold Dirección de entrega:
            b-col(cols="auto")
              b-link.text-sm(@click="editAddress = true;" v-if="!editAddress") Editar
              b-link.text-sm.text-danger(v-else @click="editAddress = false;") Cancelar
          div(v-if="!editAddress")
            p.mb-0(v-if="order.delivery_address") {{ order.delivery_address }}
            p.mb-0.text-secondary(v-else) Aún no proporcionada
          .mt-3(v-show="editAddress")
            b-form-group(label="Buscar dirección:" description="Autocompletado por Google Maps")
              b-form-input(placeholder="Buscar dirección...", v-model="address_search", id="order_address_search", autocomplete="no-autocomplete-please", @focus="$event.target.select()")
            b-form-group(v-for="(value, key) in address_dictionary" :label="value", :key="key")
              b-form-input(v-model="address[key]" :placeholder="value")
            .text-center.text-sm.text-danger(v-if="!address.delivery_latitude || !address.delivery_longitude")
              span Debes usar el buscador de dirección para poder guardarla

        .mt-3.text-right
          b-button.px-4(variant="primary", size="sm", :disabled="!delivery_type && !address.delivery_latitude || !address.delivery_longitude", @click="updateDelivery") Aplicar

    // PRODUCTS
    SideModal(v-model="products_modal" padding)
      template
        b-input-group.mb-1
          b-input-group-prepend
            b-input-group-text.bg-light Categorías
          b-form-select(v-model="category_id" :options="categories.map(c => ({ text: c.name, value: c.category_id }))" @change="getProducts")
            template(#first)
              b-form-select-option(:value="null") Todas
        b-input-group.mb-3
          b-form-input(placeholder="Buscar productos...", v-model="product_search", type="search", @input="searchProducts")
          b-input-group-append
            b-input-group-text
              search-icon.text-secondary.icon-sm
        b-list-group.mb-3
          b-list-group-item.bg-light
            b-form-row.align-items-center
              b-col
                span.font-weight-bold Productos
          b-list-group-item(v-for="(product, index) in products" :key="product.product_id")
            b-form-row.product-row
              b-col(cols="auto")
                b-img(width="70" height="70" rounded :src="product.image" :blank="!product.image" blank-color="#f2f2f2" style="object-fit:contain;")
              b-col
                b-form-row.align-items-center.justify-content-between
                  p.font-weight-bold.mb-0.ml-1 {{ product.name }}
                  .d-inline-block(v-if="!product.Product_Variants || !product.Product_Variants.length")
                    refresh-cw-icon.icon-sm.rotate-animation.mr-2.text-primary(v-if='product.loading')
                    plus-circle-icon.icon-md.pointer.text-primary.hover-success.mr-2(:disabled="!product.stock", @click="quantity_counter = 1; addProduct(product)" v-b-tooltip.hover.top="'Agregar producto'")
                    send-icon.icon-md.pointer.text-secondary.hover-primary(:disabled="!product.stock"
                    v-b-tooltip.hover.bottomleft="'Enviar al chat'",@click="sendProduct(product)")
                b-container.p-0.text-secondary.text-sm(v-if="!(product.Product_Variants && product.Product_Variants.length)")
                  b-col.p-0
                    span.font-weight-bold Precio:
                    span.ml-2 {{ product.formatted_price || product.price }}
                  b-col.p-0
                    span.font-weight-bold Stock:
                    span.ml-2 {{ product.stock || 0 }}
              b-container.mt-2.ml-0(v-if="product.Product_Variants && product.Product_Variants.length")
                .mb-2.ml-0(v-for="p_v in product.Product_Variants", :key="p_v.product_variant_id")
                  b-form-row.justify-content-between
                    b-col.text-sm
                      div(v-for="item_v in p_v.variants" :key="item_v") {{item_v}}
                    b-col.d-inline-block(cols="auto")
                      refresh-cw-icon.icon-sm.rotate-animation.mr-2.text-primary(v-if="p_v.loading")
                      plus-circle-icon.icon-md.pointer.text-primary.hover-success.mr-2(@click="quantity_counter = 1; addProductVariant(p_v)")
                      send-icon.icon-md.pointer.text-secondary.hover-primary(:disabled="!product.stock"
                      v-b-tooltip.hover.bottomleft="'Enviar al chat'" @click="sendProduct({father:product,variant:p_v},true)")
                  b-container.text-secondary.text-sm.p-0
                    b-col.p-0
                      span.font-weight-bold Precio:
                      span.ml-2 {{ p_v.formatted_price || p_v.price }}
                    b-col.p-0
                      span.font-weight-bold Stock:
                      span.ml-2 {{ p_v.stock || 0 }}
              b-container.text-secondary.text-sm.pl-0.pt-2(v-else)
                b-col.p-0
                  p.mb-2.mt-2.text-sm.text-secondary.text-truncate.text-justify.pointer.hover-info(@click="toggleDescription") {{ product.description }}

        .d-flex.align-items-center.justify-content-end
          b-pagination.mb-0(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getProducts')", v-if="v_paginationShow")
          b-spinner.ml-3(small, variant="primary", v-if="loading")

  div(v-show="!order.order_id")
    div.d-flex.align-items-center.is-justify-center(v-if="loading_order")
      b-spinner.mr-2(small variant="primary")
      span Cargando...
    p.text-center.text-help.mt-5(v-else) Aún no hay ordenes activas en el carrito de compras, selecciona "Nueva orden" para continuar
</template>

<script>
import Avatar from './Avatar.vue'
import { createNamespacedHelpers, mapActions } from 'vuex'
import _debounce from 'lodash.debounce'
import { EventBus } from '@/helpers/eventBus'
import orderStatus from '@/data/orderStatus'

const accountController = createNamespacedHelpers('account')
const categoryController = createNamespacedHelpers('category')
const locationController = createNamespacedHelpers('location')
const productController = createNamespacedHelpers('product')

window.initPlaces = function () {
  EventBus.$emit('places_loaded')
}

export default {
  data () {
    return {
      currency: 'MXN',
      timezone: '',
      order_status: orderStatus,
      orderDelivery: null,
      itemPrice: null,
      status: null,
      status_modal: false,
      discount_modal: false,
      products_modal: false,
      info_modal: false,
      delivery_modal: false,
      discount: '',
      delivery_type: null,
      pickup_location: {},
      order: {
        reference: '',
        order_id: '',
        Items: [],
        delivery_price: 0
      },
      order_summary: [],
      deliveryTypes: [
        {
          value: 'basic',
          text: 'Punto de entrega'
        },
        {
          value: 'kanguro',
          text: 'Envíos Kanguro'
        },
        {
          value: 'delivery',
          text: 'Envío a costo fijo'
        }
      ],
      selected_address: null,
      editAddress: false,
      address_search: '',
      address: {
        delivery_address: '',
        delivery_city: '',
        delivery_colony: '',
        delivery_latitude: '',
        delivery_longitude: '',
        delivery_postal_code: '',
        delivery_state: '',
        delivery_street: '',
        delivery_street_number: ''
      },
      address_dictionary: {
        delivery_address: 'Dirección',
        delivery_street: 'Calle',
        delivery_street_number: 'No. ext',
        delivery_colony: 'Colonia',
        delivery_postal_code: 'Código Postal',
        delivery_state: 'Estado'
      },
      place_fields: {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        sublocality_level_1: 'long_name',
        administrative_area_level_1: 'long_name',
        country: 'long_name',
        postal_code: 'short_name'
      },
      loading_order: false,
      notify_checkbox: true,
      category_id: null,
      loading: false,
      product_variants: {},
      orders: [],
      ordersPage: 1,
      ordersCount: 0,
      ordersLimit: 10,
      quantity_counter: 0,
      product_search: ''
    }
  },
  props: {
    conversationId: {
      type: String,
      default: null
    },
    caseId: {
      default: null
    },
    conversation: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    ...accountController.mapState({
      account: state => state.account
    }),
    ...productController.mapState({
      products: state => state.all_products
    }),
    ...categoryController.mapState({
      categories: state => state.categories
    }),
    ...locationController.mapState({
      shipping_locations: state => state.pickup_locations
    }),
    userData () {
      return (this.conversation && this.conversation.user) ? this.conversation.user : {}
    },
    userName () {
      return Object.keys(this.userData).length ? `${this.userData.first_name || ''} ${this.userData.last_name || ''}` : ''
    },
    validDiscount () {
      if (isNaN(this.discount) || this.discount > 100 || this.discount < 0) {
        return false
      } else {
        return null
      }
    },
    pickup_locations () {
      const self = this
      return this.shipping_locations.filter(l => {
        switch (self.delivery_type) {
          case 'basic':
            return !l.kanguro_origin_uuid
          case 'kanguro':
            return l.kanguro_origin_uuid
          default:
            return false
        }
      })
    },
    defined_delivery () {
      return this.delivery_type === 'basic' || this.delivery_type === 'kanguro'
    }
  },
  methods: {
    ...mapActions([
      'order/get',
      'order/create',
      'order/update',
      'order/all',
      'order/cancel',
      'order/updateStatus',
      'location/all',
      'location/get',
      'helpers/zip_code',
      'order/addDiscount',
      'product/all',
      'order/setDeliveryAddress',
      'order/setPickupLocation',
      'order/getByConversation',
      'order/geyByCase',
      'category/all',
      'delivery/ecommerce',
      'product/get',
      'product/variants',
      'order/addProduct',
      'order/addProductVariant',
      'order/removeProductVariant',
      'order/removeProduct',
      'order/getPaymentUrl',
      'product/sendProduct',
      'account/orderPayment'
    ]),
    getProducts() {
      const self = this
      this['product/all']({
        account_id: self.$route.params.account_id,
        list_all: true,
        currency: self.order.currency || 'MXN',
        params: {
          ...self.paginationParamsObject,
          category: this.category_id,
          name: this.product_search
        },
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
        }
      })
    },
    parsePrice(price = 0) {
      const { currency } = this

      price = String(price).replace('$', '')
      price = String(price).replace(',', '')
      price = String(price).replace(currency, '')

      price = price.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
      price = `${price} ${currency}`

      return price
    },
    searchProducts: _debounce(function () {
      this.resetPaginationData()
      this.getProducts()
    }, 600, { leading: false, trailing: true }),
    getProduct(product_id) {
      const self = this
      this['product/get']({
        account_id: self.$route.params.account_id,
        product_id,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    getProductVariants(product) {
      const self = this
      this.$set(product, 'loading', true)

      this['product/variants']({
        account_id: self.$route.params.account_id,
        product_id: product.product_id,
        callback: (res) => {
          product.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (res.resource.length) {
              const variants = []
              for (const v of res.resource) {
                if (!variants.some(a => a.product_variant_id == v.product_variant_id)) {
                  variants.push(v)
                }
              }

              this.$set(this.product_variants, product.product_id, variants)
            } else {
              this.addProduct(product)
            }
          }
        }
      })
    },
    getStatusName (name) {
      const status = this.order_status.find(s => s.name == name)
      if (status) {
        return status.title
      } else {
        return name
      }
    },
    getDeliveryName (value) {
      const delivery = this.deliveryTypes.find(d => d.value == value)
      if (delivery) {
        return delivery.text
      } else {
        return value
      }
    },
    getDeliverFullAddress () {
      if (this.defined_delivery) {
        const o_location = this.shipping_locations.find(l => l.pickup_location_id == this.order.pickup_location_id)
        if (o_location) {
          return o_location.full_address
        }
      }
      return this.order.delivery_address
    },
    getLocations () {
      const self = this
      // this.showLoadingScreen()

      this['location/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getEcommerceData () {
      const self = this

      this['delivery/ecommerce']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (!res.resource.pickup_enabled) {
              const index = self.deliveryTypes.findIndex(t => t.value = 'basic')
              if (index >= 0) { self.deliveryTypes.splice(index, 1) }
            }
            if (!res.resource.delivery_enabled) {
              const index = self.deliveryTypes.findIndex(t => t.value = 'kanguro')
              if (index >= 0) { self.deliveryTypes.splice(index, 1) }
            }
          }
        }
      })
    },
    createOrden () {
      const self = this
      this.loading_order = true
      this['order/create']({
        user_id: self.conversation.user_id,
        account_id: self.$route.params.account_id,
        platform: self.conversation.platform,
        callback: res => {
          self.loading_order = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.getOrder()
          }
        }
      })
    },
    getOrder () {
      if (!this.conversationId && !this.caseId) return

      const self = this
      this.loading_order = true
      let method = ''
      const params = {}

      if (this.conversationId) {
        method = 'order/getByConversation'
        params.conversation_id = this.conversationId
      }

      if (this.caseId) {
        method = 'order/geyByCase'
        params.case_id = this.caseId
      }

      this[method]({
        params,
        callback: res => {
          self.loading_order = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            const { resource } = res

            if (!resource) return
            self.order = Object.assign(self.order, resource)
            self.getProducts()

            if (self.order.pickup_location_id) { self.getLocation(self.order.pickup_location_id) }

            this.currency = resource.currency || 'MXN'
            const formater = new Intl.NumberFormat(
              undefined,
              { style: 'currency', currency: this.currency, currencyDisplay: 'code' }
            )
            this.order_summary = resource.summary ? resource.summary.slice() : ''
            this.status = resource.status || ''
            this.discount = resource.discount * 100 || 0
            this.delivery_type = resource.delivery_type || ''
            this.order.total = formater.format(resource.total) || 0
            this.order.delivery_price = Number(resource.delivery_price) || 0
            this.order.total_final = formater.format(resource.total_final) || 0
            this.order.total_final = formater.format(resource.total_final) || 0

            const firstName = this.conversation.user ? this.conversation.user.first_name : ''
            const lastName = this.conversation.user ? this.conversation.user.last_name : ''

            if (!this.order.name && (firstName || lastName)) {
              const userCompleteName = `${firstName} ${lastName}`

              this.order.name = userCompleteName.trim()
            }

            for (const key in this.address) {
              this.address[key] = this.order[key]
            }
          }
        }
      })
    },
    getLocation (pickup_location_id) {
      const self = this

      this['location/get']({
        pickup_location_id,
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.pickup_location = res.resource
          }
        }
      })
    },
    setLocation (e) {
      for (const key in e) {
        this.address[`delivery_${key}`] = e[key]
      }
      this.address.delivery_address = e.full_address
      this.address.delivery_postal_code = e.zip
      this.getColony()
    },
    updateOrder (data, silent = false) {
      this.loading = true

      this['order/update']({
        order_id: this.order.order_id,
        account_id: this.$route.params.account_id,
        ...data,
        callback: res => {
          this.loading = false
          if (res.error) return self.$message.error(res.error)
          this.getOrder()
          this.$message.success('Orden actualizada')
        }
      })
    },
    updateOrderStatus (status, confirmed = false) {
      if (status.name == 'pay_on_delivery' && !confirmed) {
        this.confirmPaymentAgaintsDelivery()
        return
      }
      const self = this

      const json_data = {
        status: status.name,
        notify: self.notify_checkbox,
        order_id: self.order.order_id,
        account_id: self.$route.params.account_id
      }

      this['order/updateStatus']({
        ...json_data,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Orden actualizada')
            self.getOrder(self.order.order_id)
            this.status_modal = false
          }
        }
      })
    },
    async confirmCreateNewOrder () {
      if (!this.order.order_id) {
        this.createOrden()
        return
      }
      try {
        const response = await this.$bvModal.msgBoxConfirm('¿Deseas crear una nueva orden? La orden actual será cancelada.', {
          title: 'Crear nueva orden y cancelar orden actual',
          okVariant: 'primary',
          okTitle: 'Continuar',
          cancelTitle: 'Cancelar'
        })

        if (response) {
          this.cancelOrder(true)
        }
      } catch (e) {
        console.error(e.message)
      }
    },
    cancelOrder (create_new = false) {
      const self = this
      this['order/cancel']({
        order_id: self.order.order_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Orden cancelada')
            if (create_new) { self.createOrden() }
          }
        }
      })
    },
    async confirmPaymentAgaintsDelivery () {
      const message = '¿Deseas poner la orden como Pago contra entrega? No puedes poner la orden nuevamente en proceso.'
      try {
        const response = await this.$bvModal.msgBoxConfirm(message, {
          title: 'Cambiar estado',
          okVariant: 'primary',
          okTitle: 'Cambiar estado',
          cancelTitle: 'Cancelar'
        })

        if (response) {
          this.updateOrderStatus(this.order_status.find(s => s.name == 'pay_on_delivery'), true)
        }
      } catch (e) {
        console.error(e.message)
      }
    },
    getColony() {
      const self = this
      this.loadingColony = true

      this['helpers/zip_code']({
        zipcode: self.address.delivery_postal_code,
        callback: res => {
          this.loadingColony = false

          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.locations = res.resource.map(element => {
              return {
                colony: element.d_asenta,
                municipality: element.D_mnpio,
                state: element.d_estado,
                city: element.d_ciudad
              }
            })

            if (self.locations.length) { this.colonyChanged(self.locations[0].colony) }
          }
        }
      })
    },
    colonyChanged (colony) {
      const location = this.locations.find(l => l.colony == colony)
      // this.colony = location.colony
      if (location) {
        this.address.delivery_municipality = location.municipality
        this.address.delivery_state = location.state
        this.address.delivery_city = location.city
      }
    },
    addDiscount (discount) {
      this['order/addDiscount']({
        account_id: this.$route.params.account_id,
        order_id: this.order.order_id,
        percent_discount: discount / 100,
        callback: res => {
          if (res.error) {
            this.$message.error(res.error)
          } else {
            this.$message.success('Orden actualizada')
            this.getOrder()
            this.discount_modal = false
          }
        }
      })
    },
    updateDelivery () {
      let action = 'order/setDeliveryAddress'
      let data = { address: { ...this.address } }

      if (this.defined_delivery) {
        action = 'order/setPickupLocation'
        data = { pickup_location_id: this.selected_address.pickup_location_id }
      }

      this[action]({
        account_id: this.$route.params.account_id,
        order_id: this.order.order_id,
        ...data,
        callback: res => {
          if (res.error) {
            return this.$message.error(res.error)
          }

          this.$message.success('Orden actualizada')
          this.getOrder()

          this.delivery_modal = false
          this.editAddress = false
          this.selected_address = null
        }
      })
    },
    getCategories () {
      const self = this
      this.loading = true

      this['category/all']({
        account_id: self.$route.params.account_id,
        params: {
          relationship: 'parent',
          limit: 100
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    updateQuantity(product, action) {
      this.quantity_counter++

      if (action === '+') {
        product.quantity++
        product.product_variant_id ? this.addProductVariant(product) : this.addProduct(product)
      } else {
        if (product.quantity > 1) {
          product.quantity--
        }

        product.product_variant_id ? this.removeProductVariant(product) : this.removeProduct(product)
      }
    },
    addProduct: _debounce(function (product) {
      product.loading = true

      this['order/addProduct']({
        account_id: this.$route.params.account_id,
        order_id: this.order.order_id,
        product_id: product.product_id,
        quantity: this.quantity_counter,
        callback: res => {
          product.loading = false
          if (res.error) {
            this.$message.error(res.error)
          } else {
            this.$message.success('Producto agregado')
            this.quantity_counter = 0
            product.stock--

            this.getOrder()
          }
        }
      })
    }, 500, {
      trailing: true,
      leading: false
    }),
    removeProduct: _debounce(function (product) {
      product.loading = true
      this['order/removeProduct']({
        account_id: this.$route.params.account_id,
        order_id: this.order.order_id,
        product_id: product.product_id,
        quantity: this.quantity_counter,
        callback: res => {
          product.loading = false
          if (res.error) {
            this.$message.error(res.error)
          } else {
            this.$message.success('Producto quitado de la orden')
            this.quantity_counter = 0

            this.getOrder()
          }
        }
      })
    }, 500, {
      trailing: true,
      leading: false
    }),
    addProductVariant: _debounce(function (p_v) {
      p_v.loading = true
      this['order/addProductVariant']({
        account_id: this.$route.params.account_id,
        order_id: this.order.order_id,
        product_variant_id: p_v.product_variant_id,
        quantity: this.quantity_counter,
        callback: res => {
          p_v.loading = false
          if (res.error) {
            this.$message.error(res.error)
          } else {
            this.$message.success('Producto agregado')
            this.quantity_counter = 0
            p_v.stock--

            this.getOrder()
          }
        }
      })
    }, 500, {
      trailing: true,
      leading: false
    }),
    removeProductVariant: _debounce(function (p_v) {
      p_v.loading = true
      this['order/removeProductVariant']({
        account_id: this.$route.params.account_id,
        order_id: this.order.order_id,
        product_variant_id: p_v.product_variant_id,
        quantity: this.quantity_counter,
        callback: res => {
          p_v.loading = false
          if (res.error) {
            this.$message.error(res.error)
          } else {
            this.$message.success('Producto removido de la orden')
            this.quantity_counter = 0

            this.getOrder()
          }
        }
      })
    }, 500, {
      trailing: true,
      leading: false
    }),
    getPaymentUrl () {
      this['order/getPaymentUrl']({
        account_id: this.$route.params.account_id,
        order_id: this.order.order_id,
        callback: res => {
          if (res.error) {
            this.$bvModal.msgBoxOk('Aún no tienes una cuenta de cobros creada. Para poder generar ligas de pago ve a Mi cuenta > Cuenta de cobros y completar tu cuenta.')
              .then(value => {
                // nothing!
              })
              .catch(err => {
                // An error occurred
              })
          } else {
            const dummy = document.createElement('textarea')
            document.body.appendChild(dummy)
            dummy.value = res
            dummy.select()
            document.execCommand('copy')
            document.body.removeChild(dummy)

            this.$bvModal.msgBoxOk('¡Listo! Ya enviamos la liga de pago a tu cliente')
              .then(value => {
                // nothing!
              })
              .catch(err => {
                // An error occurred
              })
          }
        }
      })
    },
    toggleDescription(e) {
      $(e.target).toggleClass('text-truncate')
    },
    sendProduct(product, isVariant = false) {
      const { product_id: productId } = isVariant ? product.father : product
      const { conversation_id: conversationId, account_id } = this.$route.params
      const { user_id, platform } = this.conversation
      const { currency } = this
      const params = {
        variant: isVariant ? product.variant.product_variant_id : null,
        conversationId,
        account_id,
        user_id,
        platform,
        currency
      }
      this['product/sendProduct']({
        productId,
        params,
        callback: res => {
          if (res.error) return this.$message.error(res.error)
          this.$message.success('Producto enviado')
        }
      })
    },
    generatePayment() {
      this['account/orderPayment']({
        accountId: this.$route.params.account_id,
        data: {
          payment_platform: 'niubiz',
          reference: this.order.order_id,
          user_id: this.conversation.user_id,
          order_id: this.order.order_id
        },
        callback: res => {
          if (res.error) return this.$message.error(res.error)
          this.$message.success('URL generada')
          EventBus.$emit('urlPayment', res.resource)
        }
      })
    },
    getAddressAutomatically() {
      const autocomplete = new google.maps.places.Autocomplete(
        document.getElementById('order_address_search'),
        { types: ['geocode', 'establishment'] }
      )

      autocomplete.addListener('place_changed', () => {
        this.addressInputsLocked = false
        this.addressFromMap = true
        const place = autocomplete.getPlace()

        for (let index = 0; index < place.address_components.length; index++) {
          const addressType = place.address_components[index].types[0]

          switch (addressType) {
            case 'route':
              this.address.delivery_street = place.address_components[index][this.place_fields[addressType]]
              break
            case 'street_number':
              this.address.delivery_street_number = place.address_components[index][this.place_fields[addressType]]
              break
            case 'postal_code':
              this.address.delivery_postal_code = place.address_components[index][this.place_fields[addressType]]
              break
            case 'sublocality_level_1':
              this.address.delivery_colony = place.address_components[index][this.place_fields[addressType]]
              break
            case 'locality':
              this.address.delivery_city = place.address_components[index][this.place_fields[addressType]]
              break
            case 'administrative_area_level_1':
              this.address.delivery_state = place.address_components[index][this.place_fields[addressType]]
              break
          }
        }

        this.address.delivery_latitude = place.geometry.location.lat()
        this.address.delivery_longitude = place.geometry.location.lng()
        this.address.delivery_address = place.formatted_address

        this.getColony()
      })
    }
  },
  components: { Avatar },
  mounted () {
    this.getCategories()
    this.getLocations()
    this.getEcommerceData()
    this.getOrder()
    this.timezone = this.account.timezone || 'America/Mexico_City'

    if (!document.getElementById('gmaps-api')) {
      const script = document.createElement('script')

      script.type = 'text/javascript'
      script.id = 'gmaps-api'
      script['data-name'] = 'maps-api'
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCKkhEE6RQh0YMWcc_j70iklGPAn1D
      ylZQ&libraries=places&callback=initPlaces&language=es`

      document.getElementsByTagName('head')[0].appendChild(script)
    } else {
      this.getAddressAutomatically()
    }

    EventBus.$on('places_loaded', () => {
      this.getAddressAutomatically()
    })
  },
  beforeUnmount () {
    EventBus.$off('places_loaded')
  },
  watch: {
    products_modal (value) {
      if (value === false) {
        this.getOrder()
      }
    }
  }
}
</script>

<style>
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>

<style lang="scss" scoped>
  .product-row {
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }

  .max-h-250 {
    max-height: 250px;
  }

  @keyframes rotateAnimation {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .rotate-animation {
    animation-name: rotateAnimation;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
</style>
